// extracted by mini-css-extract-plugin
export default {"icon":"cells_icon__e7O1B","cell":"cells_cell__qdVnL","link":"cells_link__S9hjr"};